import React from 'react'
import { useTranslation } from 'react-i18next'

import { TASK_PROGRESS } from 'types'

export interface TagProps {
  status: string
}

const Tag: React.FC<TagProps> = ({ status }: TagProps): JSX.Element => {
  const { t } = useTranslation('ticket')

  const taskProgress = status.charAt(0).toUpperCase() + status.slice(1)
  const statusClassName =
    taskProgress === TASK_PROGRESS.IN_PROGRESS
      ? 'in-progress'
      : taskProgress.toLowerCase().replace(/ /g, '-')

  let labelStatus = ''

  switch (taskProgress) {
    case TASK_PROGRESS.NEW:
      labelStatus = t('unassign.status')
      break

    case TASK_PROGRESS.IN_PROGRESS:
      labelStatus = t('inProgress.status')
      break

    case TASK_PROGRESS.PENDING:
      labelStatus = t('pending.status')
      break

    case TASK_PROGRESS.REJECTED:
      labelStatus = t('rejected.status')
      break

    case TASK_PROGRESS.DONE:
      labelStatus = t('done.status')
      break

    case TASK_PROGRESS.CLOSED:
      labelStatus = t('closed.status')
      break

    case TASK_PROGRESS.TRANSFERRING:
      labelStatus = t('transferring.status')
      break
  }

  return (
    <div className={`tag tag--${statusClassName}`} data-testid='tag'>
      <label className='tag__label' data-testid='tag-label'>
        {labelStatus}
      </label>
    </div>
  )
}

export default Tag
